"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Sections = _interopRequireDefault(require("../Sections"));

var _StaticReactCollection = _interopRequireDefault(require("../sections/StaticReactCollection"));

var sections = new _Sections["default"]();
sections.register('static-react-collection', function (section) {
  return new _StaticReactCollection["default"](section);
});